import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { RichText, useBlockProps } from '@wordpress/block-editor';
/**
 * Internal dependencies
 */

import { escape } from './utils';
export default function save(_ref) {
  let {
    attributes
  } = _ref;
  return createElement("pre", useBlockProps.save(), createElement(RichText.Content, {
    tagName: "code",
    value: escape(attributes.content)
  }));
}
//# sourceMappingURL=save.js.map